import styled from 'styled-components'
import { belowPhone } from 'utilities/styled'
import HeroActionsBase from 'components/hero-actions'

export const HeroActions = styled(HeroActionsBase)`
    ${belowPhone`
        &.has-selected {
            display: none;
        }
    `}
`